import { TRoute, USER_ROLE } from "@/shared/types/route.ts";
import { lazy } from "react";

const Dashboard = lazy(() => import("@/dashboard/pages/dashboard"));

const DASHBOARD_URL = Object.freeze({
  DASHBOARD: "/dashboard-example",
  NOT_FOUND: "*", // catch-all route
});

const HOMEPAGE_ROUTE: TRoute = {
  name: "Dashboard",
  path: DASHBOARD_URL.DASHBOARD,
  component: Dashboard,
  roles: [USER_ROLE.DASHBOARD],
};
const DASHBOARD_ROUTE = Object.freeze({
  HOMEPAGE_ROUTE,
});

export { DASHBOARD_URL, DASHBOARD_ROUTE };